import React from "react";
import {Redirect, Switch} from "react-router-dom";

import ErrorBoundaryRoute from "../../../../containers/ErrorBoundaryRoute";
import Collection from "./components/Memberships";
import History from "./components/MembershipHistory";
import Object from "./components/Membership";

const isEmployee = (roles) => parseInt(roles, 10) === 2;

export default ({match, roles}) => {
	const hideMembershipHistory = isEmployee(roles);

	return (
		<div>
			<Switch>
				<ErrorBoundaryRoute exact path={`${match.url}`}>
					<Collection roles={roles}/>
				</ErrorBoundaryRoute>

				<ErrorBoundaryRoute exact path={`${match.url}/history`}>
					{hideMembershipHistory ? <Redirect to="/memberships"/> : <History/>}
				</ErrorBoundaryRoute>

				<ErrorBoundaryRoute path={`${match.url}/:id`}>
					<Object baseUrl={`${match.url}`} roles={roles}/>
				</ErrorBoundaryRoute>

				<ErrorBoundaryRoute>
					<Redirect to={`${match.url}`}/>
				</ErrorBoundaryRoute>
			</Switch>
		</div>
	);
};
